export function Sticker({
  children,
  className = "",
  rotate = "-rotate-2",
  bg = "bg-white",
}) {
  return (
    <span
      className={`inline-flex items-center gap-1.5 rounded-full border-2 border-ink ${bg} px-3.5 py-1.5 font-sans text-[11px] font-bold uppercase tracking-[0.12em] text-ink shadow-chunk ${rotate} ${className}`}
    >
      {children}
    </span>
  );
}

export function Starburst({ text, className = "", color = "#C8DCF2" }) {
  const points = Array.from({ length: 24 }, (_, i) => {
    const r = i % 2 === 0 ? 50 : 39;
    const a = (Math.PI * i) / 12;
    return `${50 + r * Math.sin(a)},${50 - r * Math.cos(a)}`;
  }).join(" ");
  return (
    <div
      className={`relative flex h-24 w-24 items-center justify-center ${className}`}
      aria-hidden="true"
    >
      <svg
        viewBox="0 0 100 100"
        className="absolute inset-0 h-full w-full drop-shadow-[3px_3px_0_#1C1917]"
      >
        <polygon points={points} fill={color} stroke="#1C1917" strokeWidth="2" />
      </svg>
      <span className="relative z-10 px-3 text-center font-display text-[11px] font-extrabold uppercase leading-tight tracking-tight text-ink">
        {text}
      </span>
    </div>
  );
}
